import React, { useState } from "react";

import { Calendar, Funnel, Search } from "lucide-react";

import { TextInput } from "../shared/Inputs";
import { ISelectOption, Select } from "../shared/Selects";

export const ReportHistory = () => {

    const ranges: ISelectOption[] = [
        { value: "7", label: "Last 7 days" },
        { value: "30", label: "Last 30 days" },
        { value: "90", label: "Last 90 days" },
        { value: "custom", label: "Custom Range" },
    ];

    const departments: ISelectOption[] = [
        { value: "all-scenarios", label: "All Scenarios" },
        { value: "audit-deja-vu", label: "Audit Déjà Vu" },
        { value: "urgent-risk-request", label: "The Urgent Risk Request" },
        { value: "soft-down-case", label: "The Soft Down Case" },
        { value: "incomplete-initiative-submission", label: "The Incomplete Initiative Submission" },
        { value: "trusted-customers", label: "Trusted Customers" },
        { value: "extra-drawer-keys", label: "Extra Drawer Keys" },
        { value: "veteran-branch-manager", label: "The Veteran Branch Manager" },
        { value: "the-slogan-backlash", label: "The Slogan Backlash" },
        { value: "toxic-rockstar-reality-check", label: "The Toxic Rockstar’s Reality Check" },
        { value: "the-skeptical-ciso", label: "The Skeptical CISO" },
    ];

    const [currentTab, setCurrentTab] = useState<'mcsa' | 'mbts'>('mcsa');
    const [selectedRange, setSelectedRange] = useState<ISelectOption>(ranges[0]);
    const [selectedDepartment, setSelectedDepartment] = useState<ISelectOption>(departments[0]);

    return (
        <div className="report_history__page">
            <p className='text-4xl text-bold color--primary mb-md'>Report History</p>
            <p className='text-lg color--txt-secondary mb-2xl'>Review your past assessments and simulations.</p>
            <div className="report_history__tabs">
                <button
                    className={`report_history__tabs__btn ${currentTab === 'mcsa' ? 'report_history__tabs__btn--active' : ''}`}
                    onClick={() => setCurrentTab('mcsa')}
                >
                    MCSA
                </button>
                <button
                    className={`report_history__tabs__btn ${currentTab === 'mbts' ? 'report_history__tabs__btn--active' : ''}`}
                    onClick={() => setCurrentTab('mbts')}
                >
                    MBTS
                </button>
            </div>
            <div className="report_history__filters">
                <TextInput
                    icon={{ icon: <Search />, position: 'prefix' }}
                    placeholder="Search"
                />
                <Select
                    postBtnIcon={<Calendar />}
                    selected={selectedRange}
                    options={ranges}
                    onSelect={(option) => setSelectedRange(option)}
                />
                <Select
                    postBtnIcon={<Funnel />}
                    selected={selectedDepartment}
                    options={departments}
                    onSelect={(option) => setSelectedDepartment(option)}
                />
            </div>
            <div className="report_history__data">
                <div className="report_history__data__table_wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th><p className="text-xs text-medium color--txt-disabled text-left">Date</p></th>
                                <th><p className="text-xs text-medium color--txt-disabled text-left">Scenario</p></th>
                                <th><p className="text-xs text-medium color--txt-disabled text-left">Score</p></th>
                                <th><p className="text-xs text-medium color--txt-disabled text-left">Action</p></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><p className="text-sm color--txt-tertiary">Jan 22, 2026</p></td>
                                <td><p className="text-sm text-medium">Reporting Concerns</p></td>
                                <td><p className="text-sm color--txt-tertiary">4.1/5</p></td>
                                <td><button className="link link--primary text-sm text-semibold">View Report</button></td>
                            </tr>
                            <tr>
                                <td><p className="text-sm color--txt-tertiary">Jan 22, 2026</p></td>
                                <td><p className="text-sm text-medium">Reporting Concerns</p></td>
                                <td><p className="text-sm color--txt-tertiary">4.1/5</p></td>
                                <td><button className="link link--primary text-sm text-semibold">View Report</button></td>
                            </tr>
                            <tr>
                                <td><p className="text-sm color--txt-tertiary">Jan 22, 2026</p></td>
                                <td><p className="text-sm text-medium">Reporting Concerns</p></td>
                                <td><p className="text-sm color--txt-tertiary">4.1/5</p></td>
                                <td><button className="link link--primary text-sm text-semibold">View Report</button></td>
                            </tr>
                            <tr>
                                <td><p className="text-sm color--txt-tertiary">Jan 22, 2026</p></td>
                                <td><p className="text-sm text-medium">Reporting Concerns</p></td>
                                <td><p className="text-sm color--txt-tertiary">4.1/5</p></td>
                                <td><button className="link link--primary text-sm text-semibold">View Report</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};